<template>
    <div
        v-if="slider"
        :class="{
            'value-slider': true,
            'interaction': true,
            'value-slider--disabled': evaluating || disabled,
        }"
    >
        <div class="value-slider__value">
            <span v-text="value" class="value-slider__value-number"/>{{ slider.unit }}
        </div>

        <vue-slider
            class="value-slider__slider"
            v-model="value"
            :tooltip="false"
            :disabled="disabled || evaluating"
            :min="parseFloat(this.slider.valueFrom)"
            :max="parseFloat(this.slider.valueTo)"
            :process-dragable="true"
            :interval="parseFloat(this.slider.steps)"
        />

        <interaction-evaluator
            v-if="!evaluatesExternal"
            :evaluating="evaluating"
            :feedback="feedback"
            :evaluation="evaluation"
            @evaluate="evaluate"
            @retry="reset"
            @solve="solve"
        />

    </div>
</template>

<script>
import vueSlider from 'vue-slider-component';
import ButtonElement from '@/components/elements/ButtonElement.vue';
import InteractionEvaluator from '@/components/elements/quiz/InteractionEvaluator.vue';

export default {
    name: 'ValueSliderElement',
    components: {
        vueSlider,
        ButtonElement,
        InteractionEvaluator,
    },
    props: {
        slider: {
            type: Object,
            required: true,
        },
        feedback: Object,
        evaluatesExternal: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            evaluating: false,
            evaluation: {
                passed: false,
            },
            value: 0,
        }
    },
    computed: {
        valueWithUnit() {
            const { unit } = this.slider;

            return `${this.value} ${unit}`;
        }
    },
    mounted() {
        this.reset();
    },
    methods: {
        evaluate() {

            if (this.evaluating || this.disabled) { return; }

            const { valueFromCorrect, valueToCorrect } = this.slider;

            this.evaluation = Object.assign({}, this.evaluation, {
                passed: this.value >= parseFloat(valueFromCorrect) &&
                    this.value <= parseFloat(valueToCorrect)
            });

            this.evaluating = true;

            return this.evaluation;
        },
        reset() {
            this.value = parseInt(this.slider.valueInitial);
            this.evaluating = false;

            this.evaluation = Object.assign({}, this.evaluation, {
                passed: false
            });
        },
        solve() {

            const { valueFromCorrect, valueToCorrect } = this.slider;
            const exactValue = (parseFloat(valueFromCorrect) + parseFloat(valueToCorrect)) / 2;

            this.value = exactValue;
        }
    }
}
</script>
